/* Quick add modal — opens on "+" click, actually adds to cart via /cart/add.js */
(function () {
  function closeAllModals() {
    document.querySelectorAll('[data-quickadd-modal]').forEach(function (modal) {
      modal.classList.remove('is-open');
      modal.hidden = true;
    });
    document.body.classList.remove('quickadd-modal-open');
  }

  function openModal(modal) {
    closeAllModals();

    /* Move the modal to be a direct child of <body>. Product cards can sit inside
       elements that get a CSS transform applied (scroll-reveal animations, hover
       zoom, etc), and any transformed ancestor breaks "position: fixed" — the
       modal ends up pinned to that ancestor's position instead of the actual
       viewport, which is what caused the cropped/stuck behaviour. Re-parenting
       to <body> guarantees it's never inside a transformed element. */
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    modal.hidden = false;
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
    });
    document.body.classList.add('quickadd-modal-open');
  }

  function selectSize(sizeBtn) {
    var wrap = sizeBtn.closest('[data-quickadd-sizes]');
    wrap.querySelectorAll('.quickadd-size-btn').forEach(function (btn) {
      btn.classList.remove('is-selected');
    });
    sizeBtn.classList.add('is-selected');

    var panel = sizeBtn.closest('.quickadd-modal__panel');
    var atcBtn = panel.querySelector('[data-quickadd-atc]');
    atcBtn.dataset.variantId = sizeBtn.getAttribute('data-variant-id');
    atcBtn.disabled = false;
  }

  function addToCart(atcBtn) {
    var variantId = atcBtn.dataset.variantId;
    if (!variantId) return;

    var panel = atcBtn.closest('.quickadd-modal__panel');
    var message = panel.querySelector('[data-quickadd-message]');

    atcBtn.disabled = true;
    atcBtn.classList.add('is-loading');
    if (message) {
      message.hidden = true;
      message.classList.remove('is-error');
    }

    var cartAddUrl = (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add.js';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        atcBtn.classList.remove('is-loading');
        atcBtn.disabled = false;

        if (!result.ok || result.data.status) {
          if (message) {
            message.hidden = false;
            message.textContent = (result.data && result.data.description) || 'Something went wrong — please try again.';
            message.classList.add('is-error');
          }
          return;
        }

        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        closeAllModals();
      })
      .catch(function () {
        atcBtn.classList.remove('is-loading');
        atcBtn.disabled = false;
        if (message) {
          message.hidden = false;
          message.textContent = 'Something went wrong — please try again.';
          message.classList.add('is-error');
        }
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quickadd-trigger]');
    if (trigger) {
      event.preventDefault();
      var modal = document.getElementById(trigger.getAttribute('data-modal-id'));
      if (modal) openModal(modal);
      return;
    }

    if (event.target.closest('[data-quickadd-close]')) {
      event.preventDefault();
      closeAllModals();
      return;
    }

    var sizeBtn = event.target.closest('.quickadd-size-btn');
    if (sizeBtn && !sizeBtn.disabled) {
      selectSize(sizeBtn);
      return;
    }

    var atcBtn = event.target.closest('[data-quickadd-atc]');
    if (atcBtn && !atcBtn.disabled) {
      event.preventDefault();
      addToCart(atcBtn);
      return;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAllModals();
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-quickadd-sizes]').forEach(function (wrap) {
      var firstAvailable = wrap.querySelector('.quickadd-size-btn:not(.quickadd-size-btn--unavailable)');
      if (firstAvailable) selectSize(firstAvailable);
    });
  });
})();
